import React from "react";
import { graphql } from "react-relay";

import { connectMicrosoftTodo, microsoftTodoKey } from "~/settings/Integrations/MicrosoftTodo/MicrosoftTodoIntegration";
import type { IntegrationDetailsType } from "~/stream/StreamSettings/ActionItemIntegrations";

import type { ActionItemIntegration } from "../actionItemIntegration";
import { CreateNewExternalTicketPane } from "./MicrosoftTodoCreateNewExternalTicketPane";
import { ImportExistingTicketPane } from "./MicrosoftTodoImportExistingTicketPane";
import MicrosoftTodoLogo from "./MicrosoftTodoLogo";
import { MicrosoftTodoActionItemIntegrationLinkWidget } from "./Widget";

import styles from "~/integrations/actionItemIntegration/css/styles.module.css";

graphql`
	fragment microsoftTodoSpecificData on MicrosoftTodoActionItemIntegrationSpecificDataNode {
		__typename
		externalTaskId
		externalListId
		externalListName
		status
		microsoftTodoUser {
			isConnected
		}
	}
`;

// Microsoft To Do doesn't have a series level integration, so we don't need to fetch any series details
function useMicrosoftTodoStreamIntegrationDetails(_integrationOrAsanaStream: IntegrationDetailsType) {
	return { containerTitle: "", createdBy: "", includeAiGenerated: true };
}

export const microsoftTodo: ActionItemIntegration = {
	key: microsoftTodoKey,
	logo: <MicrosoftTodoLogo className={styles.integrationLogo} />,
	billingFeatureName: "microsoft_todo_integration",
	displayName: "Microsoft To Do",
	externalActionItemName: "task",
	externalContainerType: "list",
	promptAuth: connectMicrosoftTodo,
	renderPill: MicrosoftTodoActionItemIntegrationLinkWidget,
	renderCreateNewExternalTicketPane: CreateNewExternalTicketPane,
	renderImportExistingExternalTicketPane: ImportExistingTicketPane,
	useIntegrationDetails: useMicrosoftTodoStreamIntegrationDetails,
};
